import docReady from '../../../assets/js/docReady';
import { logAnalyticsEvent } from '../../../assets/js/helpers/bananas';

class ModelContractWidget {
    constructor(element, energyProducts) {
        this.element = element;
        this.productElements = [];
        this.modelProductElement = [];
        this.houseHoldEstimate = 2;
        this.errorElement = null;
        this.filterToggleElement = null;
        this.products = energyProducts;
        this.averageModelYearPrice = 0;
        this.apiUrl = 'https://api-energie.keuze.nl/v1/compare/yZv4mJs9qTfWcQz6-554';
        this.noGas = false;
        this.inputs = {
            usageInputs: [],
            hasSolarInput: null,
            noGasInput: null,
        };

        this.baseFilter = {
            electricity: 1250,
            electricity_off_peak: 1250,
            gas: 1000,
            electricity_double_meter: true,
            providers: [],
            include_gift_value: true,
            group_provider_products: true,
            tariff_type: 'fixed',
            electricity_generated: false,
            electricity_generation: 2500,
        };
    }

    bootstrap() {
        this.modelProductElement = this.element.querySelector('.model-contract-product');
        this.productElements = this.element.querySelectorAll('.regular-contract-product');
        this.errorElement = this.element.querySelector('.error-screen');
        this.filterToggleElement = this.element.querySelector('.filter-toggle');
        this.inputs.usageInputs = this.element.querySelectorAll('[name="household-radio"]');
        this.inputs.hasSolarInput = this.element.querySelector('#has-solar');
        this.inputs.noGasInput = this.element.querySelector('#no-gas');
        this.inputs.usageInputs.forEach((input) => {
            if (input.checked) {
                this.houseHoldEstimate = input.value;
            }
            input.addEventListener('change', () => {
                logAnalyticsEvent('model-contract-widget.change-household', input.value);
                this.setLoading(true);
                this.houseHoldEstimate = input.value;
                this.setUsageEstimate(input.value);
                setTimeout(() => {
                    this.getProducts();
                }, 50);
            });
        });
        this.inputs.hasSolarInput.addEventListener('change', () => {
            logAnalyticsEvent('model-contract-widget.has-solar', this.inputs.hasSolarInput.checked);
            this.setLoading(true);
            this.baseFilter.electricity_generated = this.inputs.hasSolarInput.checked;
            setTimeout(() => {
                this.getProducts();
            }, 50);
        });
        this.inputs.noGasInput.addEventListener('change', () => {
            logAnalyticsEvent('model-contract-widget.no-gas', this.inputs.noGasInput.checked);
            this.setLoading(true);
            this.noGas = this.inputs.noGasInput.checked;
            this.setUsageEstimate(this.houseHoldEstimate);
            setTimeout(() => {
                this.getProducts();
            }, 50);
        });

        this.filterToggleElement.addEventListener('click', () => {
            this.filterToggleElement.parentElement.classList.toggle('show');
        });
    }

    init() {
        this.bootstrap();
    }

    setUsageEstimate(estimate) {
        switch (estimate) {
        case '1':
            this.baseFilter.electricity = 750;
            this.baseFilter.electricity_off_peak = 750;
            this.baseFilter.electricity_generation = (this.baseFilter.electricity * 2);
            this.baseFilter.gas = this.noGas ? 0 : 900;
            break;
        case '2':
            this.baseFilter.electricity = 1250;
            this.baseFilter.electricity_off_peak = 1250;
            this.baseFilter.electricity_generation = (this.baseFilter.electricity * 2);
            this.baseFilter.gas = this.noGas ? 0 : 1000;
            break;
        case '3':
            this.baseFilter.electricity = 1750;
            this.baseFilter.electricity_off_peak = 1750;
            this.baseFilter.electricity_generation = (this.baseFilter.electricity * 2);
            this.baseFilter.gas = this.noGas ? 0 : 1500;
            break;
        case '4':
            this.baseFilter.electricity = 2250;
            this.baseFilter.electricity_off_peak = 2250;
            this.baseFilter.electricity_generation = (this.baseFilter.electricity * 2);
            this.baseFilter.gas = this.noGas ? 0 : 1700;
            break;
        case '5':
            this.baseFilter.electricity = 2500;
            this.baseFilter.electricity_off_peak = 2500;
            this.baseFilter.electricity_generation = (this.baseFilter.electricity * 2);
            this.baseFilter.gas = this.noGas ? 0 : 1800;
            break;
        default:
            this.baseFilter.electricity = 1250;
            this.baseFilter.electricity_off_peak = 1250;
            this.baseFilter.electricity_generation = (this.baseFilter.electricity * 2);
            this.baseFilter.gas = this.noGas ? 0 : 1000;
        }
    }

    updateWidget() {
        this.updateModelProduct();

        this.productElements.forEach((productElement, index) => {
            if (this.products[index] === undefined) {
                return;
            }
            const product = this.products[index];
            this.updateRow(productElement, product);
        });

        setTimeout(() => {
            this.setLoading(false);
        }, 250);
    }

    setLoading(loading) {
        if (loading) {
            this.element.classList.add('is-loading');
        } else {
            this.element.classList.remove('is-loading');
        }
    }

    setError(error) {
        if (error) {
            this.errorElement.classList.add('show');
        } else {
            this.errorElement.classList.remove('show');
        }
    }

    updateModelProduct() {
        this.modelProductElement.querySelector('[data-replace="month_price"]').innerHTML = `${Math.round(this.averageModelYearPrice / 12)},-`;
    }

    updateRow(row, product) {
        const discount = this.averageModelYearPrice - product.year_price;
        if (discount <= 0) {
            row.style.display = 'none';
        } else {
            row.style.display = null;

            row.querySelectorAll('[data-replace]')
                .forEach((element) => {
                    switch (element.dataset.replace) {
                    case 'month_price':
                        element.innerHTML = `${Math.round(product.month_price)},-`;
                        break;
                    case 'provider_logo':
                        element.src = product.provider_logo;
                        break;
                    case 'savings':
                        element.innerHTML = `€ ${Math.round(this.averageModelYearPrice - product.year_price)}`;
                        break;
                    }
                });
        }
    }

    getProducts() {
        this.fetchData()
            .then((data) => {
                this.products = data.products;
                this.averageModelYearPrice = data.model_contract_yearly;
            })
            .then(() => {
                this.updateWidget();
            });
    }

    fetchData() {
        this.setError(false);

        const filter = {
            ...this.baseFilter,
        };
        const params = new URLSearchParams(filter);
        return fetch(`${this.apiUrl}?${params}`, {
            type: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                this.setError(true);
                throw new Error('Network response was not ok.');
            })
            .then((data) => data)
            .catch((error) => {
                this.setError(true);
            });
    }
}

docReady(() => {
    const widgets = document.querySelectorAll('.model-contract-widget');
    const {
        energyProducts,
    } = window;

    widgets.forEach((widget) => {
        const widgetInstance = new ModelContractWidget(widget, energyProducts);
        widgetInstance.init();
    });
});
